import {Shell} from '@hconnect/uikit/src/lib2'

import {RefraPlannerFooter} from './RefraPlannerFooter'
import {RefraPlannerHeader} from './RefraPlannerHeader'

interface RefraPlannerHeaderProps {
  children: React.ReactNode
}

export const RefraPlannerLayout: React.FC<RefraPlannerHeaderProps> = ({children}) => {
  return (
    <Shell
      header={<RefraPlannerHeader />}
      footer={<RefraPlannerFooter />}
      boxed={false}
      isResponsive
    >
      {children}
    </Shell>
  )
}
